import { get as getPathValue } from "lodash";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { isBlockArray } from "@circle-react-shared/BuilderUI/Helpers/typePredicates";

export const getBlockPathInfo = (path: string) => {
  // eslint-disable-next-line sonarjs/prefer-regexp-exec -- Disabled for plugin version update. Fix when possible
  const arrayIndexMatch = path.match(/\.(\d+)$/);

  const currentIndex = arrayIndexMatch ? parseInt(arrayIndexMatch[1], 10) : -1;
  const relativePath = path.replace(/^blocks\./, "");
  const parentArrayPath = path.replace(/\.\d+$/, "");
  const relativeParentPath = parentArrayPath.replace(/^blocks\./, "");

  return {
    currentIndex,
    relativePath,
    relativeParentPath,
  };
};

export const getParentArray = (blocks: BaseBlock, relativePath: string) => {
  const parentArray: unknown = getPathValue(blocks, relativePath);
  return isBlockArray(parentArray) ? parentArray : null;
};
